// @mui
import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { EmployeeProps } from 'src/@types/employee';
import TeamMember from './TeamMember';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(8, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(15, 0),
  },
}));

// ----------------------------------------------------------------------

type Props = {
  members: EmployeeProps[];
};

export default function Team({ members }: Props) {
  return (
    <RootStyle>
      <Container>
        <Typography
          variant="h2"
          sx={{
            textAlign: 'center',
            mb: { xs: 8, md: 10 },
          }}
        >
          Administrasjonen
        </Typography>

        <Box
          sx={{
            display: 'grid',
            rowGap: { xs: 4, md: 5 },
            columnGap: 3,
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(4, 1fr)',
            },
          }}
        >
          {members.map((member) => (
            <TeamMember key={member._id} member={member} />
          ))}
        </Box>
      </Container>
    </RootStyle>
  );
}
